import React from 'react'

import { StatusIndicator } from '@octane/spark'

import { IconWrapper } from './ApplicationStatusIndicator.styled'

interface ApplicationStatusProps {
    status: string
}

function ApplicationStatusIndicator({
    status,
}: Readonly<ApplicationStatusProps>) {
    return (
        <IconWrapper status={status}>
            <StatusIndicator
                iconPosition="left"
                text={status}
                variant="noStatus"
            />
        </IconWrapper>
    )
}

export default ApplicationStatusIndicator
